import { createTracker } from 'usage-tracker';
import events from 'ExportDialog/events.yaml';
export const UsageTracker = createTracker({
  events,
  properties: {
    namespace: 'salesimportui'
  },
  debug: false // enable to see events in console
});